import React from "react";
import { Box, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import NotificationCard from "../components/NotificationCard";
import IconBox from "../../../../components/icons/IconBox";
import { Player } from "@lottiefiles/react-lottie-player";

const notificationsType = [
  {
    id: 1,
    name: "Send via SMS",
    icon: "https://assets9.lottiefiles.com/packages/lf20_0o15jarv.json",
    description: "Send SMS to group",
    button: "Send",
    path: "/dashboard/group/sms",
  },
  {
    id: 2,
    name: "Send via App",
    icon: "https://assets4.lottiefiles.com/packages/lf20_tgeyhrvk.json",
    description: "Send In-App notification to group",
    button: "In App",
    path: "/dashboard/group/app",
  },
  {
    id: 3,
    name: "Create Group",
    icon: "https://assets2.lottiefiles.com/packages/lf20_ihuxdwgl.json",
    description: "Create a new notification group",
    button: "Create",
    path: "/dashboard/group/create",
  },
];

function Index() {
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 6 }}
        gap="20px"
        mb="20px"
      >
        {notificationsType.map((card, i) => (
          <NotificationCard
            key={i}
            startContent={
              <IconBox
                w="60px"
                h="60px"
                bg={boxBg}
                icon={
                  <Player
                    autoplay
                    loop
                    src={card.icon}
                    style={{ height: "120px", width: "120px" }}
                  ></Player>
                }
              />
            }
            name={card.name}
            description={card.description}
            value={card.button}
            path={card.path}
          />
        ))}
      </SimpleGrid>
    </Box>
  );
}

export default Index;
